// bk09 Bookie Pearl — paper-invitation preview. Outer pearl foil,
// inner card uses template's bg/ink/accent. Eyebrow "TAKLIFNOMA" → art-deco
// half-fan medallion (or photo) → names in template font → date and
// venue caption.

import { Photo, type LayoutCtx } from "./_shared";

const PEARL_GRADIENT =
  "linear-gradient(135deg, #C4C6C0 0%, #E4E4DC 22%, #F0EFE9 45%, #E4E4DC 65%, #B8BBB5 100%)";

export function BookiePearlPreviewLayout({
  names, date, venue, accent, ink, bg, font, photo,
}: LayoutCtx) {
  const captionDate = formatDate(date);
  return (
    <div style={{ position: "absolute", inset: 0, background: PEARL_GRADIENT, padding: "5%", display: "flex" }}>
      <div
        style={{
          flex: 1,
          background: bg,
          color: ink,
          position: "relative",
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}55`,
        }}
      >
        <div style={{ fontFamily: "var(--font-ui)", fontSize: 7, fontWeight: 700, letterSpacing: "0.4em", color: accent, marginBottom: "5%" }}>
          TAKLIFNOMA
        </div>

        {/* Pearl half-fan medallion */}
        <div style={{ width: "62%", aspectRatio: "1/1", position: "relative", marginBottom: "5%" }}>
          <div style={{ position: "absolute", inset: 0, borderRadius: "50%", background: PEARL_GRADIENT, padding: "5%" }}>
            <div style={{ width: "100%", height: "100%", borderRadius: "50%", background: bg, padding: "4%", boxSizing: "border-box" }}>
              <div style={{ width: "100%", height: "100%", borderRadius: "50%", overflow: "hidden", position: "relative" }}>
                <Photo
                  src={photo}
                  style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}
                  fallback={
                    <svg viewBox="0 0 100 100" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}>
                      <defs>
                        <radialGradient id="bk09-bg" cx="50%" cy="60%" r="55%">
                          <stop offset="0%" stopColor={accent} stopOpacity="0.28" />
                          <stop offset="100%" stopColor={bg} stopOpacity="0" />
                        </radialGradient>
                      </defs>
                      <rect width="100" height="100" fill="url(#bk09-bg)" />
                      <g stroke={accent} strokeWidth="0.9" strokeLinecap="round">
                        <line x1="50" y1="72" x2="20" y2="36" />
                        <line x1="50" y1="72" x2="32" y2="24" />
                        <line x1="50" y1="72" x2="42" y2="18" />
                        <line x1="50" y1="72" x2="50" y2="14" />
                        <line x1="50" y1="72" x2="58" y2="18" />
                        <line x1="50" y1="72" x2="68" y2="24" />
                        <line x1="50" y1="72" x2="80" y2="36" />
                        <path d="M22 38 Q 50 22 78 38" fill="none" strokeWidth="0.6" />
                      </g>
                      <circle cx="50" cy="72" r="2.4" fill={accent} />
                      <circle cx="50" cy="72" r="5" fill="none" stroke={accent} strokeWidth="0.5" />
                    </svg>
                  }
                />
                <div style={{ position: "absolute", inset: 0, background: `linear-gradient(180deg, transparent 55%, ${accent}22 100%)` }} />
              </div>
            </div>
          </div>
        </div>

        <div style={{ fontFamily: font, fontStyle: "italic", fontSize: 28, lineHeight: 1.05, color: ink }}>
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div style={{ fontFamily: "var(--font-ui)", fontSize: 6.5, fontWeight: 700, letterSpacing: "0.32em", color: accent, marginTop: "4%" }}>
          SAVE THE DATE · {captionDate}
        </div>
        <div style={{ fontFamily: "var(--font-ui)", fontSize: 6, fontWeight: 600, letterSpacing: "0.28em", color: `${ink}99`, marginTop: 6 }}>
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}

function formatDate(d: string): string {
  const m = d.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (!m) return d.toUpperCase();
  const months = [
    "YANVAR", "FEVRAL", "MART", "APREL", "MAY", "IYUN",
    "IYUL", "AVGUST", "SENTABR", "OKTABR", "NOYABR", "DEKABR",
  ];
  return `${parseInt(m[1], 10)} ${months[parseInt(m[2], 10) - 1] ?? ""} ${m[3]}`;
}
